export class StatisticsManager {
    constructor(data) {
        this._adapters = data.scriptManager.activateScripts(data.statistics);
    }
    trackPage(pathName, pageTitle = '', pageLocation = '') {
        this._adapters.forEach((adapter) => {
            adapter.trackPage(pathName, pageTitle, pageLocation);
        });
    }
    trackEvent(event) {
        this._adapters.forEach((adapter) => {
            adapter.trackEvent(event);
        });
    }
}
